import api from "../services/api/api";
import { localStorageHandler } from "./helpers";

export const requestOTPHandler = async (
  email: string,
  method: string,
  companyName?: string
): Promise<any> => {
  try {
    let res = await api.post(
      "/Auth/GetOTP",
      companyName ? { email, method, companyName } : { email, method }
    );
    return res;
  } catch (error) {
    return { error };
  }
};
export const signInHandler = async (otpCode: string, endPoint: string): Promise<any> => {
  try {
    let res = await api.post(`/Auth/${endPoint}`, { otpCode });
    return res;
  } catch (error) {
    return { error };
  }
};

export const logOutHandler = () => {
  localStorageHandler("clear");
};
